import React, { Component } from "react";
import { Grid, Image, Container } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import moment from "moment";
import { SyncLoader } from "react-spinners";

import { APP_NAME } from "../../constants/resource.constants";
import { DEFAULT_PROFILE_IMG } from "../../constants/profile.constants";
import { BASE_URL } from "../../constants/route.constants";
import ClubHistoryBasic from "../../components/ClubHistory/ClubHistoryBasic";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";
import { capitaliseFirstLetters } from "../../utility";

export default class UserPage extends Component {
  componentWillMount() {
    this.props.requestUser(this.props.match.params.id);
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  getProfileImage() {
    return this.props.friend.photo || DEFAULT_PROFILE_IMG;
  }

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          {this.props.friend && this.props.friend.firstName ? (
            <div>
              <Helmet>
                <title>
                  {`
                ${capitaliseFirstLetters(
                  this.props.friend.firstName
                )} ${capitaliseFirstLetters(this.props.friend.lastName)} |
                ${APP_NAME}`}
                </title>
                <meta
                  name="description"
                  content={`GAA International user account for ${capitaliseFirstLetters(
                    this.props.friend.firstName
                  )} ${capitaliseFirstLetters(this.props.friend.lastName)}`}
                />
                <link
                  rel="canonical"
                  href={`${BASE_URL}${window.location.pathname}`}
                />
                <meta
                  property="og:title"
                  content={`${capitaliseFirstLetters(
                    this.props.friend.firstName
                  )} ${capitaliseFirstLetters(
                    this.props.friend.lastName
                  )} | ${APP_NAME}`}
                />
                <meta
                  property="og:description"
                  content={`GAA International profile page for ${capitaliseFirstLetters(
                    this.props.friend.firstName
                  )} ${capitaliseFirstLetters(this.props.friend.lastName)}`}
                />
                <meta
                  property="og:image"
                  content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
                />
                <meta
                  property="og:url"
                  content={`${BASE_URL}${window.location.pathname}/`}
                />
                <meta property="og:type" content="website" />
              </Helmet>

              <Grid columns={3} stackable={true}>
                <Grid.Column width={5}>
                  <Image src={this.getProfileImage()} />
                  <h4>General</h4>
                  <span className="date">
                    Joined in {moment(this.props.friend.joined).format("YYYY")}
                  </span>
                </Grid.Column>
                <Grid.Column width={8}>
                  <h1>
                    {this.props.friend.firstName} {this.props.friend.lastName}
                  </h1>
                  <label>Favorite Position</label>
                  <p>{this.props.friend.position}</p>
                  <label>Current Country</label>
                  <p>{this.props.friend.country}</p>
                  <h4>Clubs</h4>
                  {this.props.friend.clubs &&
                  this.props.friend.clubs.length > 0 ? (
                    <ClubHistoryBasic
                      clubs={this.props.friend.clubs}
                      history={this.props.history}
                    />
                  ) : (
                    " "
                  )}
                </Grid.Column>
                <Grid.Column width={3} />
              </Grid>
            </div>
          ) : (
            <div className="spinner__container">
              <SyncLoader loading={true} margin="7px" color="#007849" />
            </div>
          )}
        </Container>
        <Footer />
      </div>
    );
  }
}

UserPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/UserPage/View.js